module.exports = __webpack_public_path__ + "static/Vira Shanty-f7aca031fcdcaec601192f94273c90d4.jpg";